import React, { useState, useEffect } from 'react';
import { BsX } from 'react-icons/bs';
import { SlDiamond } from "react-icons/sl";
import { useNavigate } from "react-router-dom";

import { useTranslation } from 'react-i18next';
import { ProductColors } from '../ProductColors';

//import '../../css/ShoppingCart.css'
import '../../style/miniCart.scss';


const MiniCart = ({ setShowMiniCart, showMiniCart, activeCountry, activeLanguage, cart, handleQuantityChange, setItemInCart }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        if (showMiniCart) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

        // Cleanup to restore scroll on unmount
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [showMiniCart]);

    const handleCloseMiniCart = () => {
        setShowMiniCart(false);
    }

    const handleGoToCheckout = () => {
        navigate("/" + activeLanguage.shortCode + '-' + activeCountry.iso + '/checkout');
        setShowMiniCart(false);
    }

    const handleGoToProduct = (productUri) => {
        navigate(productUri);
        setShowMiniCart(false);
    }

    const handleResetCart = () => {
        if(confirm('Vill du återställa varukorgen?')) {
            fetch('/Api/System/Shop/Session/Cart/ResetCart')
                .then(response => response.json())
                .then(data => setItemInCart({products: []}));
        }
    }

    return (
        <>
            <div className="shoppingcart-container">
                <div className="shoppingcart-header-icon">
                    <BsX size={24} color="#000" onClick={handleCloseMiniCart} />
                </div>
                <div className="shoppingcart-header">
                    <SlDiamond size={41} />
                    <h2 className="shoppingcart-header-text">{t('shop-AddedProducts')}</h2>
                </div>
                <div className="shoppingcart-products">
                    {cart.products.length > 0 ? (
                        cart.products.map((product) => {

                            const colorPropertiesId = product.properties
                                .filter(prop => prop.type === 'color')
                                .map(prop => prop.propertyId);

                            const sizeValue = product.properties
                                .filter(prop => prop.type === 'size')
                                .map(prop => prop.value);

                            return (
                                <div key={product.productId} className="cart-item-container">
                                    <div className="cart-item-image" onClick={() => handleGoToProduct(product.uri)}>
                                        <img src={product.image} alt={product.name} />
                                    </div>
                                    <div className="cart-item-details">
                                        <div className="cart-item-details-row">
                                            <h2 className="cart-item-title" onClick={() => handleGoToProduct(product.uri)}>{product.name}</h2>
                                            <div className="cart-item-color">
                                                <div className="color-container">
                                                    {/* Displaying color circles based on propertyId */}
                                                    {colorPropertiesId.map((propertyId, index) => {
                                                        const color = ProductColors[propertyId];

                                                        if (color) {
                                                            // If it's an array (multiple colors), render each color as a split circle
                                                            if (Array.isArray(color)) {
                                                                return (
                                                                    <div
                                                                        key={index}
                                                                        className="color-circle-split"
                                                                        style={{
                                                                            background: `linear-gradient(to right, ${color[0]} 50%, ${color[1]} 50%)`
                                                                        }}
                                                                        aria-label={`Color: ${color[0]} / ${color[1]}`}
                                                                    />
                                                                );
                                                            }
                                                            // If it's a single color, render just that one color
                                                            return (
                                                                <div
                                                                    key={index}
                                                                    className="color-circle"
                                                                    style={{ backgroundColor: color }}
                                                                    aria-label={`Color: ${color}`}
                                                                />
                                                            );
                                                        }
                                                        return null;
                                                    })}
                                                </div>
                                            </div>
                                        </div>

                                        <p className="cart-item-price">{product.displayPrice}</p>
                                        <div
                                            className="size-box"
                                        >
                                            {sizeValue}
                                        </div>

                                        <div className="cart-item-counter">
                                            <button onClick={() => handleQuantityChange(product.productId, 'decrease')} className="counter-button">-</button>
                                            <span className="counter-value">{product.quantity}</span>
                                            <button onClick={() => handleQuantityChange(product.productId, 'increase')} className="counter-button">+</button>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <p className="empty-cart">{t('shop-cartEmpty')}</p>
                    )}
                </div>
                <div className="cart-total-sum">
                    <p>{t('shop-cartSum')}&nbsp;</p>
                    <p>{cart.displayFinalValue}</p>
                </div>
                <button className="shoppingcart-button" onClick={handleGoToCheckout}>{t('shop-ToCheckout')}</button>
                <button className="keepshopping-button" onClick={handleCloseMiniCart}>{t('shop-ContinueShopping')}</button>
                <button className="keepshopping-button" onClick={handleResetCart}>{t('shop-ResetCart')}</button>
            </div>
            {showMiniCart && <div className="overlay" onClick={handleCloseMiniCart} />}
        </>
    );
}

export default MiniCart;